import MostComprehensive from '../../../assets/img/the-most-comprehensive.png';

export default function RegisterSection() {
  return (
    <>
      <section className="padding-tb-70px sm-ptb-30px" id="register">
        <div className="container">
          <div className="">
            <div className="row">
              <div className="col-md-6 visible-sm">
                <img width="100%" className="" src={MostComprehensive} alt="Repute" />
              </div>
              <div
                className="col-md-6 wow fadeInRight"
                data-wow-duration="1.5s"
                data-wow-offset="10"
              >
                <div className="firo-title dark text-md-right margin-top-150px margin-right-30px margin-right-sm-0px sm-mb-20px sm-mt-30px">
                  <h2 className="title">The most comprehensive test series there is</h2>
                  <div className="description line-height-30">
                    Our classes are equipped with audio-visual support which aid to the learning
                    experience.These classes also transform into live demonstration platform during
                    lectures.
                  </div>
                  <a href="contact.php" className="firo-bottom sm mt-20">
                    Register for a course
                  </a>
                </div>
              </div>
              <div
                className="col-md-6 hidden-sm wow fadeInLeft"
                data-wow-duration="1.5s"
                data-wow-offset="10"
              >
                <img width="100%" className="" src={MostComprehensive} alt="Repute" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
